// extracted by mini-css-extract-plugin
export default {"queue-body":"queue-list_queue-body__qHfrG","chat-items":"queue-list_chat-items__w9mN1","loader":"queue-list_loader__pY-Tf","spinner":"queue-list_spinner__YyEXi"};